import React, { useContext } from 'react'
import { Box, Text } from '@pancakeswap/uikit'
import { ArcadeContext } from 'Providers'

function GameIcon({ game }) {
  const { setCurrentGame } = useContext(ArcadeContext)
  const iconContainerStyle: any = {
    width: '104px',
    textAlign: 'center',
    marginLeft: '16px',
    marginTop: '16px',
    marginBottom: '16px',
    cursor: 'pointer',
  }
  const iconStyle: any = { height: '70px', width: '70px', borderRadius: '16px' }

  return (
    <>
      <Box style={iconContainerStyle} onClick={() => setCurrentGame(game)}>
        <img src={game.imgSrc} alt="" style={iconStyle} loading="lazy" />
        <Text color="white" fontSize="20px" textAlign="center">
          {game.title}
        </Text>
      </Box>
    </>
  )
}

export default GameIcon
